import { InlineIcon } from "@iconify/react";
import _ from "lodash";
import React from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../jss_setup";
import PropTypes from "prop-types";

const stepStyles = createUseStyles({
  Step: (props) => ({
    display: "grid",
    justifyItems: "center",
    alignContent: "baseline",
    position: "relative",
    maxWidth: "5rem",
    ..._.get(props, "customStyles.Step", {}),
    "&:not(:last-child):after": {
      content: `""`,
      position: "absolute",
      width: "2rem",
      left: "90%",
      top: "1rem",
      transform: "translateY(-50%)",
      height: "2px",
      background: "lightgray",
    },
  }),
  number: (props) => ({
    width: "2rem",
    display: "grid",
    height: "2rem",
    justifyItems: "center",
    alignItems: "center",
    borderRadius: "50%",
    fontSize: "large",
    fontWeight: "bold",
    background: props.isActiveStep
      ? jssVariables.colors.background.light
      : jssVariables.colors.base_color,
    color: props.isActiveStep
      ? jssVariables.colors.base_color
      : jssVariables.colors.text.light,
    border: `1px solid ${
      props.isActiveStep ? jssVariables.colors.base_color : "none"
    }`,
    ..._.get(props, "customStyles.number", {}),
  }),
  label: (props) => ({
    textAlign: "center",
    textTransform: "capitalize",
    ..._.get(props, "customStyles.label", {}),
  }),
  icon: (props) => ({
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    Step: (props) => ({
      display: "grid",
      "&:not(:last-child):after": {
        width: "6rem!important",
        left: "100%",
      },
      ..._.get(props, "customStyles.Step..smallscreen", {}),
    }),
  },
});
const Step = ({ label, index, currentStep }) => {
  const classes = stepStyles({ isActiveStep: currentStep === index });

  return (
    <div className={classes.Step}>
      <div className={classes.number} id={`bookingStep_${index + 1}`}>
        {currentStep <= index ? (
          index + 1
        ) : (
          <InlineIcon icon="subway:tick" className={classes.icon} />
        )}
      </div>
      <div className={classes.label}>{label}</div>
    </div>
  );
};
Step.defaultProps = {
  label: "",
  index: 0,
  currentStep: 0,
};
Step.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
};
const styles = createUseStyles({
  Steppper: (props) => ({
    padding: 0,
    ..._.get(props, "customStyles.Steppper", {}),
  }),
  steps: (props) => ({
    display: "grid",
    gridTemplateColumns: `repeat(${props.stepsNo}, 5rem)`,
    gridGap: jssVariables.normal_gap,
    justifyContent: "center",
    ..._.get(props, "customStyles.steps", {}),
  }),
  divider: (props) => ({
    marginTop: "1rem",
    height: ".1rem",
    width: "3vw",
    background: "gray",
    ..._.get(props, "customStyles.divider", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    steps: (props) => ({
      gridGap: "6rem",
      ..._.get(props, "customStyles.steps", {}),
    }),
  },
});
const Stepper = ({ steps, current }) => {
  const classes = styles({ stepsNo: steps.length });

  return (
    <div className={classes.Steppper}>
      <div className={classes.steps}>
        {steps.length > 0 &&
          steps.map((step, idx) => (
            <Step key={idx} label={step} index={idx} currentStep={current} />
          ))}
      </div>
    </div>
  );
};
Stepper.defaultProps = {
  steps: [],
  current: 0,
};
Stepper.propTypes = {
  steps: PropTypes.array.isRequired,
  current: PropTypes.number.isRequired,
};
export default Stepper;
